// src/components/VerifyAdminCode.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/VerifyAdminCode.css';

const VerifyAdminCode = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [verificationLink, setVerificationLink] = useState('');
  const navigate = useNavigate();

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const urlEmail = params.get('email');
  const urlCode = params.get('code');

  if (urlEmail) {
    setEmail(urlEmail);
    localStorage.setItem('adminEmail', urlEmail);
  } else {
    const storedEmail = sessionStorage.getItem('adminEmail') || localStorage.getItem('adminEmail');
    if (storedEmail) {
      setEmail(storedEmail);
    } else {
      setError('No email found. Please log in again.');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }
  }

  if (urlCode) {
    setCode(urlCode);
  }
}, [navigate]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch('https://clinic123.onrender.com/api/auth/verify-admin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code }),
      });

      const data = await res.json();

      if (res.ok) {
        alert('Admin verification successful!');
        sessionStorage.removeItem('adminEmail');
        localStorage.removeItem('adminEmail');
        navigate('/dashboard');
      } else {
        setError(data.error || 'Invalid verification code');
      }
    } catch (err) {
      setError('Something went wrong.');
    }

    setLoading(false);
  };

  const handleResendCode = async () => {
    setError('');
    setVerificationLink('');
    try {
      const res = await fetch('https://clinic123.onrender.com/api/auth/resend-admin-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        alert('A new code has been sent to your email.');
        setVerificationLink(
          `Didn't get redirected? Click here to verify: ${window.location.origin}/verify-admin-code`
        );
      } else {
        setError(data.error || 'Failed to resend code');
      }
    } catch (err) {
      setError('Something went wrong while resending code.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Verify Admin Code</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="code">Enter the code sent to your email</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />
          </div>
          {error && <p style={{ color: 'red', marginBottom: '1rem' }}>{error}</p>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Verifying...' : 'Verify Code'}
          </button>
        </form>

        <button
          type="button"
          className="login-button"
          onClick={handleResendCode}
          style={{ marginTop: '1rem', backgroundColor: '#6c757d' }}
        >
          Resend Code
        </button>
        {verificationLink && (
          <p style={{ marginTop: '1rem' }}>
            <a href="/verify-admin-code">{verificationLink}</a>
          </p>
        )}
      </div>
    </div>
  );
};

export default VerifyAdminCode;
